<life-di-nav></life-di-nav>
<lifedi-breadcrumb lastPath="เพิ่ม Consult"></lifedi-breadcrumb>

<h4 style="margin-left: 5vw; padding-left: 1rem;">วันที่ {{ date | date:'full' }}</h4>

<div class="container">
  <div *ngIf="consultDetails && times" class="row mt-5">
    <div class="btn-group btn-group-toggle col-2"
      [ngClass]="{'offset-1': i === 0 || i === 5 || i === 10 }" *ngFor="let c of consultDetails; let i = index;">
      <label *ngIf="c.CONSULT_STATUS === 'empty' || c.CONSULT_STATUS === 'delete'" class="btn-empty" ngbButtonLabel
        style="margin-bottom: 25px; border-color: #58595B;">
        <input type="checkbox" ngbButton [(ngModel)]="status[i]" (click)="add($event, c, i)">
        {{ getHourse(times[i]) }}
      </label>
      <label *ngIf="c.CONSULT_STATUS === 'busy' || c.CONSULT_STATUS === 'edit'" class="btn-busy" ngbButtonLabel
        style="margin-bottom: 25px;">
        <input type="checkbox" ngbButton [(ngModel)]="status[i]" (click)="edit($event, c, i)">
        {{ getHourse(times[i]) }}
      </label>
      <label *ngIf="c.CONSULT_STATUS === 'joined'" class="btn-joined" ngbButtonLabel style="margin-bottom: 25px;">
        <input type="checkbox" ngbButton [(ngModel)]="status[i]" disabled="true">
        {{ getHourse(times[i]) }}
      </label>
    </div>
  </div>
  <div class="row justify-content-center mt-4">
    <lifedi-btn *ngIf="moreThanOne(selected)" lable="บันทึก consult" (click)="create()"
      customStyle="background: #005C3D; color: #FFFFFF; margin-top: 0px; padding: 0 25px;">
    </lifedi-btn>
    <lifedi-btn *ngIf="!moreThanOne(selected)" lable="บันทึก consult" disabled="true"
      customStyle="margin-top: 0px; padding: 0 25px;">
    </lifedi-btn>
  </div>
</div>
